
import FeatherIcon from 'feather-icons-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// types
import { Feature } from './types';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import SalesDashBoard from 'assets/images/hero/New folder/SalesDashBoard.png';
import QuoteAndSalesChart from 'assets/images/hero/New folder/QuoteAndSalesChart.png';
import LeadsOpportunitiAccounts from 'assets/images/hero/New folder/LeadsOpportunitiAccounts.png';
import LeadReport from 'assets/images/hero/New folder/Features/LeadReport.png';
import Das from 'assets/images/hero/New folder/Features/Das.png';
import LeadView from 'assets/images/hero/New folder/Features/LeadView.png';
import leadsDetailsView from 'assets/images/hero/New folder/leadsDetailsView.png';
import CampaginView from 'assets/images/hero/New folder/Features/CampaginView.png';

import SupportTicketHistory from 'assets/images/hero/New folder/SupportTicketHistory.png';
import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
import AccountsDetailsView from 'assets/images/hero/New folder/AccountsDetailsView.png';
import opportunityDetails from 'assets/images/hero/New folder/opportunityDetails.png';
import "./Benefits.css";
import { useState } from 'react';
import { colors } from 'styles/colors';
import { Link } from 'react-router-dom';


type FeaturesProps = {
    features: Feature[];
};

const Features = ({ features }: FeaturesProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const slides = [SalesDashBoard, QuoteAndSalesChart, LeadsOpportunitiAccounts, leadsDetailsView, opportunityDetails, campaginDetailsView, AccountsDetailsView];
    const [activeText, setActiveText] = useState(0);

    const slidesData = [
        {
            image: LeadReport, // tuza image variable name change kar
            text: [
                "Get a comprehensive overview of your lead performance with total leads, conversion rate, and key activity metrics displayed at the top.",
                "Visualize your sales pipeline through an intuitive lead funnel, showing how leads progress across different stages from new to closed.",
                "Analyze lead distribution by status using a detailed chart, helping you identify bottlenecks and improve conversion efficiency."
            ]
        },
        {
            image: SalesDashBoard,
            text: [
                "Monitor how sales orders are distributed across different execution stages. Get clear visibility into delivery and processing performance.",
                "Understand your overall sales performance with key business metrics. Track revenue trends and order efficiency in one unified dashboard."
            ]
        },
        {
            image: QuoteAndSalesChart,
            text: [
                "Monitor the overall quote performance and track how efficiently they convert into orders. This chart highlights your conversion effectiveness and sales closing strength.",
                "Analyze lead progression across contacted, nurturing, qualified, and active stages. Gain insights into overall sales performance and deal outcomes."
            ]
        },
        {
            image: Das,
            text: [
                "Stay informed about lead movement and engagement status in real time.",
                "Visualize deal progress from active discussions to closed outcomes.",
                "Understand account distribution by type to identify key business segments."
            ]
        },
        {
            image: LeadView,
            text: [
                "Access complete lead information including contact, company, and activity details.",
                "Track status updates and interactions in one centralized view."
            ]
        },

        {
            image: CampaginView,
            text: [
                "This screen provides a detailed view of the selected campaign, including campaign information, schedule, and current status.",
                "It also displays distribution details and campaign form responses for each assigned user in a structured format."
            ]
        }
    ];

    const SlideCard = ({ index }: { index: number }) => (
        <Row className="align-items-center g-4 mb-4">
            <Col md={12}>
                <div className="slide-card p-4 rounded shadow-sm h-100">
                    {slidesData[index]?.text.map((paragraph, i) => (
                        <p key={i} className="slide-card-paragraph mb-2">
                            {/* {paragraph} */}
                            <span className="bullet-dot">•</span> {paragraph}
                        </p>
                    ))}

                </div>
            </Col>

        </Row>
    );



    return (
        <>
            {/* <Container> */}

            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3rem, 6vw, 5rem) 0',
                    background: '#fafbfc',
                }}
            >
                {/* Decorative elements */}
                <svg style={{ position: 'absolute', top: '40px', right: '5%', opacity: 0.07, pointerEvents: 'none' }} width="70" height="70" viewBox="0 0 70 70" fill="none">
                    {[0, 18, 36, 54].map(x => [0, 18, 36, 54].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#24347D" />))}
                </svg>
                <div style={{ position: 'absolute', bottom: '-40px', left: '-30px', width: '200px', height: '200px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.05) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    <Row className="align-items-center g-5" id="ai">
                        {/* Left Content */}
                        <Col lg={6}>
                            {/* Pill badge */}
                            <div
                                className="d-inline-flex align-items-center mb-3"
                                style={{
                                    gap: '8px',
                                    background: '#e8f7f8',
                                    borderRadius: '50px',
                                    padding: '6px 18px',
                                }}
                            >
                                <FeatherIcon icon="cpu" style={{ width: '14px', height: '14px', color: colors.primary.teal }} />
                                <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.teal }}>
                                    AI Features
                                </span>
                            </div>

                            <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3, marginBottom: '14px' }}>
                                Automate Follow-ups &{' '}
                                <span style={{ color: colors.primary.teal }}>Communication</span>
                            </h2>

                            <p style={{ fontSize: '1rem', lineHeight: 1.8, color: '#6b7280', marginBottom: '24px' }}>
                                Use AI to draft campaign emails, suggest next steps, and speed up support ticket assignment — so your team focuses on closing and helping customers.
                            </p>

                            {/* Feature checklist */}
                            <div className="d-flex flex-column" style={{ gap: '14px' }}>
                                {[
                                    { icon: 'mail', text: 'AI email draft for campaigns', accent: '#3b82f6' },
                                    { icon: 'bell', text: 'Smart follow-up reminders via tasks', accent: '#f59e0b' },
                                    { icon: 'headphones', text: 'Support ticket allocation by AI/email', accent: '#10b981' },
                                ].map((item, i) => (
                                    <div
                                        key={i}
                                        className="d-flex align-items-center"
                                        style={{
                                            gap: '14px',
                                            background: '#fff',
                                            border: '1px solid #eaeaea',
                                            borderRadius: '12px',
                                            padding: '14px 16px',
                                            transition: 'all 0.25s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = item.accent;
                                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#eaeaea';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{
                                                width: '38px',
                                                height: '38px',
                                                borderRadius: '10px',
                                                background: `${item.accent}14`,
                                            }}
                                        >
                                            <FeatherIcon icon={item.icon} style={{ width: '17px', height: '17px', color: item.accent }} />
                                        </div>
                                        <span style={{ fontSize: '0.93rem', fontWeight: 500, color: '#374151' }}>{item.text}</span>
                                    </div>
                                ))}
                            </div>
                        </Col>

                        {/* Right Content - AI Draft Preview Card */}
                        <Col lg={6}>
                            <div
                                style={{
                                    background: '#fff',
                                    borderRadius: '18px',
                                    border: '1px solid #eaeaea',
                                    padding: 'clamp(1.5rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.06)';
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                {/* Top accent bar */}
                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: `linear-gradient(90deg, ${colors.primary.darkBlue}, ${colors.primary.teal})`, borderRadius: '18px 18px 0 0' }} />

                                {/* Card header */}
                                <div className="d-flex align-items-center" style={{ gap: '10px', marginBottom: '18px', marginTop: '4px' }}>
                                    <div
                                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '10px',
                                            background: `linear-gradient(135deg, ${colors.primary.darkBlue}, ${colors.primary.teal})`,
                                        }}
                                    >
                                        <FeatherIcon icon="edit-3" style={{ width: '16px', height: '16px', color: '#fff' }} />
                                    </div>
                                    <span style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a1a2e' }}>AI Draft Preview</span>
                                </div>

                                {/* Email preview */}
                                <div
                                    style={{
                                        background: '#f8f9fb',
                                        borderRadius: '12px',
                                        border: '1px solid #f0f0f0',
                                        padding: '18px',
                                        marginBottom: '18px',
                                    }}
                                >
                                    <p style={{ fontSize: '0.88rem', fontWeight: 600, color: '#374151', margin: '0 0 10px' }}>
                                        <span style={{ color: '#9ca3af' }}>Subject:</span> Quick follow-up on your request
                                    </p>
                                    <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: '#6b7280', margin: 0 }}>
                                        <span style={{ fontWeight: 600, color: '#374151' }}>Hi</span>{' '}
                                        <span style={{ background: '#fef3c7', padding: '2px 6px', borderRadius: '4px', fontWeight: 600, color: '#92400e' }}>
                                            {'{Name}'}
                                        </span>
                                        , thanks for reaching out. Based on your needs, here are the next best steps...
                                    </p>
                                </div>

                                {/* Tags */}
                                <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                                    <span
                                        style={{
                                            background: '#ecfdf5',
                                            color: '#059669',
                                            fontSize: '0.78rem',
                                            fontWeight: 600,
                                            padding: '6px 16px',
                                            borderRadius: '50px',
                                            border: '1px solid #a7f3d0',
                                        }}
                                    >
                                        Personalized
                                    </span>
                                    <span
                                        style={{
                                            background: '#eef2ff',
                                            color: '#4338ca',
                                            fontSize: '0.78rem',
                                            fontWeight: 600,
                                            padding: '6px 16px',
                                            borderRadius: '50px',
                                            border: '1px solid #c7d2fe',
                                        }}
                                    >
                                        On-brand
                                    </span>
                                    <span
                                        style={{
                                            background: '#f1f5f9',
                                            color: '#475569',
                                            fontSize: '0.78rem',
                                            fontWeight: 600,
                                            padding: '6px 16px',
                                            borderRadius: '50px',
                                            border: '1px solid #e2e8f0',
                                        }}
                                    >
                                        Fast
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* </Container> */}



            {/* ============================Features========================== */}

            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3rem, 6vw, 5rem) 0',
                    background: 'linear-gradient(180deg, #fafbfc 0%, #fff 100%)',
                }}
            >
                {/* Decorative elements */}
                <svg style={{ position: 'absolute', top: '50px', left: '4%', opacity: 0.06, pointerEvents: 'none' }} width="80" height="80" viewBox="0 0 80 80" fill="none">
                    {[0, 20, 40, 60].map(x => [0, 20, 40, 60].map(y => <circle key={`${x}-${y}`} cx={x + 5} cy={y + 5} r="2.5" fill="#24347D" />))}
                </svg>
                <svg style={{ position: 'absolute', bottom: '40px', right: '5%', opacity: 0.05, pointerEvents: 'none' }} width="60" height="60" viewBox="0 0 60 60" fill="none">
                    {[0, 20, 40].map(x => [0, 20, 40].map(y => <circle key={`${x}-${y}`} cx={x + 5} cy={y + 5} r="2" fill="#26A2AB" />))}
                </svg>
                <div style={{ position: 'absolute', top: '-50px', right: '-40px', width: '220px', height: '220px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.04) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Section header */}
                    <div className="text-center mb-5">
                        <div
                            className="d-inline-flex align-items-center mb-3"
                            style={{ gap: '8px', background: '#eef2ff', borderRadius: '50px', padding: '6px 18px' }}
                        >
                            <FeatherIcon icon="grid" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                                Features
                            </span>
                        </div>
                        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3 }}>
                            Powerful Modules to{' '}
                            <span style={{ color: colors.primary.teal }}>Grow Your Business</span>
                        </h2>
                        <p style={{ color: '#6b7280', fontSize: '1rem', maxWidth: '560px', margin: '8px auto 0' }}>
                            Manage customers, close more deals, and scale your operations with ease.
                        </p>
                    </div>

                    <Row className="g-4">
                        {features.map((benefit, index) => {
                            const accentColors = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#06b6d4', '#ec4899', '#14b8a6'];
                            const accentBgs = ['#eff6ff', '#ecfdf5', '#fefce8', '#f5f3ff', '#fef2f2', '#ecfeff', '#fdf2f8', '#f0fdfa'];
                            const accent = accentColors[index % accentColors.length];
                            const accentBg = accentBgs[index % accentBgs.length];
                            return (
                                <Col xs={12} sm={6} lg={4} key={index}>
                                    <div
                                        className="h-100 d-flex flex-column text-center"
                                        style={{
                                            background: '#fff',
                                            borderRadius: '18px',
                                            border: '1px solid #eaeaea',
                                            padding: 'clamp(1.5rem, 3vw, 2rem) clamp(1.2rem, 2vw, 1.5rem)',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-6px)';
                                            e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.07)';
                                            e.currentTarget.style.borderColor = accent;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                            e.currentTarget.style.borderColor = '#eaeaea';
                                        }}
                                    >
                                        {/* Top accent bar */}
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: accent, borderRadius: '18px 18px 0 0' }} />

                                        {/* Icon */}
                                        <div
                                            className="d-flex align-items-center justify-content-center mx-auto mb-3"
                                            style={{
                                                width: '56px',
                                                height: '56px',
                                                borderRadius: '16px',
                                                background: accentBg,
                                                marginTop: '6px',
                                            }}
                                        >
                                            <FeatherIcon icon={benefit.icon} style={{ width: '24px', height: '24px', color: accent }} />
                                        </div>

                                        {/* Title */}
                                        <h5 style={{ fontSize: '1rem', fontWeight: 700, color: colors.primary.darkBlue, marginBottom: '8px' }}>
                                            {benefit.title}
                                        </h5>

                                        {/* Description */}
                                        <p className="flex-grow-1 mb-0" style={{ fontSize: '0.88rem', lineHeight: 1.7, color: '#6b7280' }}>
                                            {benefit.description}
                                        </p>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            </section>


            <section
                style={{
                    background: `linear-gradient(135deg, ${colors.primary.darkBlue} 0%, #1e3a8a 50%, ${colors.primary.teal} 100%)`,
                    borderRadius: '24px',
                    margin: '40px 16px',
                    padding: 'clamp(2.5rem, 5vw, 4rem) clamp(1.5rem, 4vw, 3rem)',
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                {/* Decorative blobs */}
                <div style={{ position: 'absolute', top: '-40px', left: '-40px', width: '180px', height: '180px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-30px', right: '-30px', width: '140px', height: '140px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />

                <div style={{ position: 'relative', zIndex: 1 }}>
                    <div
                        className="d-inline-flex align-items-center mb-3"
                        style={{ gap: '8px', background: 'rgba(255,255,255,0.12)', borderRadius: '50px', padding: '6px 18px' }}
                    >
                        <FeatherIcon icon="zap" style={{ width: '13px', height: '13px', color: '#fff' }} />
                        <span style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#fff' }}>
                            Get Started Today
                        </span>
                    </div>

                    <h2 style={{ fontSize: 'clamp(1.4rem, 3vw, 2rem)', fontWeight: 800, color: '#fff', lineHeight: 1.3, marginBottom: '12px' }}>
                        Ready to grow your sales pipeline?
                    </h2>
                    <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.75)', maxWidth: '480px', margin: '0 auto 32px', lineHeight: 1.7 }}>
                        See SalesTrackify in action or explore our CRM guides to make a confident decision.
                    </p>

                    <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ gap: '16px' }}>
                        <Link
                            to="/contact"
                            className="d-inline-flex align-items-center"
                            style={{
                                gap: '8px',
                                background: colors.primary.teal,
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '0.95rem',
                                padding: '14px 32px',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                                transition: 'all 0.25s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={(e) => {
                                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
                                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 12px 32px rgba(0,0,0,0.2)';
                            }}
                            onMouseLeave={(e) => {
                                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
                                (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
                            }}
                        >
                            <FeatherIcon icon="calendar" style={{ width: '16px', height: '16px' }} />
                            Book a Demo
                        </Link>

                        <Link
                            to="/blogs"
                            className="d-inline-flex align-items-center"
                            style={{
                                gap: '8px',
                                background: 'rgba(255,255,255,0.12)',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                padding: '14px 32px',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                border: '1.5px solid rgba(255,255,255,0.3)',
                                transition: 'all 0.25s ease',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={(e) => {
                                (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.2)';
                                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.12)';
                                (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
                            }}
                        >
                            <FeatherIcon icon="book-open" style={{ width: '16px', height: '16px' }} />
                            Read CRM Guides
                        </Link>
                    </div>
                </div>
            </section>


            <section className="position-relative py-5">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

                    <SlideCard index={activeIndex} />

                    <div className="swiper-wrapper-custom px-7">

                        <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            loop={true}
                            speed={1200}
                            pagination={{
                                clickable: true
                            }}
                            spaceBetween={0}
                            navigation={{
                                prevEl: ".swiper-button-prev-custom",
                                nextEl: ".swiper-button-next-custom",
                            }}
                            onBeforeInit={(swiper) => {
                                // @ts-ignore
                                swiper.params.navigation.prevEl = ".swiper-button-prev-custom";
                                // @ts-ignore
                                swiper.params.navigation.nextEl = ".swiper-button-next-custom";
                                // @ts-ignore
                            }}
                            onSlideChange={(swiper) => {
                                setActiveIndex(swiper.realIndex);
                            }}
                        >
                            {slidesData.map((slide, idx) => (
                                <SwiperSlide key={idx}>
                                    <img src={slide.image} alt={`slide-${idx}`} className="simple-img" />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <div className="swiper-button-prev-custom nav-btn left mx-2">‹</div>
                        <div className="swiper-button-next-custom nav-btn right mx-2">›</div>
                    </div>
                </Container>
            </section>

            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3.5rem, 7vw, 5.5rem) 0',
                    background: 'linear-gradient(180deg, #fff 0%, #f4f6fb 100%)',
                }}
            >
                {/* Decorative dots */}
                <svg style={{ position: 'absolute', top: '30px', right: '4%', opacity: 0.06, pointerEvents: 'none' }} width="80" height="80" viewBox="0 0 80 80" fill="none">
                    {[0, 20, 40, 60].map(x => [0, 20, 40, 60].map(y => <circle key={`${x}-${y}`} cx={x + 5} cy={y + 5} r="2.5" fill="#24347D" />))}
                </svg>
                <div style={{ position: 'absolute', bottom: '-60px', left: '-50px', width: '260px', height: '260px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Section header */}
                    <div className="text-center mb-5">
                        <div
                            className="d-inline-flex align-items-center mb-3"
                            style={{ gap: '8px', background: '#eef2ff', borderRadius: '50px', padding: '6px 18px' }}
                        >
                            <FeatherIcon icon="award" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                                Why SalesTrackify
                            </span>
                        </div>
                        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.1rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3, marginBottom: '12px' }}>
                            Why Choose Our{' '}
                            <span style={{ color: colors.primary.teal }}>CRM ?</span>
                        </h2>
                        <p style={{ color: '#6b7280', fontSize: '1rem', maxWidth: '560px', margin: '0 auto' }}>
                            Choosing the right CRM is essential for business growth. Here's what sets SalesTrackify apart.
                        </p>
                    </div>

                    {/* 3-column cards */}
                    <Row className="g-4">
                        {[
                            {
                                icon: 'users',
                                accent: '#3b82f6',
                                accentBg: '#eff6ff',
                                title: 'Complete CRM Feature Set',
                                body: 'SalesTrackify offers everything you need to manage leads, track sales performance, and improve customer relationships — all from a single, unified platform.',
                            },
                            {
                                icon: 'cpu',
                                accent: '#10b981',
                                accentBg: '#ecfdf5',
                                title: 'Built for Growing SMBs',
                                body: 'Designed for small and medium businesses, our platform combines real-time dashboards, AI-powered suggestions, and easy-to-use automation so your team can focus more on closing deals.',
                            },
                            {
                                icon: 'target',
                                accent: colors.primary.teal,
                                accentBg: '#e8f7f8',
                                title: 'End-to-End Sales Optimization',
                                body: 'From lead generation to deal closure, every step is optimized to deliver better results. SalesTrackify gives you a reliable CRM solution to scale your business efficiently.',
                            },
                        ].map((card, i) => (
                            <Col md={4} key={i}>
                                <div
                                    className="h-100 d-flex flex-column"
                                    style={{
                                        background: '#fff',
                                        borderRadius: '20px',
                                        border: '1px solid #eaeaea',
                                        padding: 'clamp(1.5rem, 3vw, 2rem)',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-6px)';
                                        e.currentTarget.style.boxShadow = '0 20px 48px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.borderColor = card.accent;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = '#eaeaea';
                                    }}
                                >
                                    {/* Top accent bar */}
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: card.accent, borderRadius: '20px 20px 0 0' }} />

                                    {/* Icon */}
                                    <div
                                        className="d-flex align-items-center justify-content-center mb-4"
                                        style={{
                                            width: '54px',
                                            height: '54px',
                                            borderRadius: '16px',
                                            background: card.accentBg,
                                            marginTop: '8px',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <FeatherIcon icon={card.icon} style={{ width: '24px', height: '24px', color: card.accent }} />
                                    </div>

                                    {/* Number badge */}
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ gap: '10px', marginBottom: '10px' }}
                                    >
                                        <span
                                            style={{
                                                fontSize: '0.7rem',
                                                fontWeight: 700,
                                                color: card.accent,
                                                background: card.accentBg,
                                                borderRadius: '50px',
                                                padding: '3px 10px',
                                                letterSpacing: '0.5px',
                                            }}
                                        >
                                            {String(i + 1).padStart(2, '0')}
                                        </span>
                                    </div>

                                    {/* Title */}
                                    <h5 style={{ fontSize: '1.05rem', fontWeight: 800, color: '#1a1a2e', marginBottom: '10px' }}>
                                        {card.title}
                                    </h5>

                                    {/* Body */}
                                    <p className="flex-grow-1 mb-0" style={{ fontSize: '0.9rem', lineHeight: 1.75, color: '#6b7280' }}>
                                        {card.body}
                                    </p>

                                    {/* Bottom divider accent */}
                                    <div style={{ marginTop: '1.5rem', height: '2px', width: '40px', background: card.accent, borderRadius: '2px', opacity: 0.4 }} />
                                </div>
                            </Col>
                        ))}
                    </Row>

                    {/* Bottom stat strip */}
                    <div
                        className="d-flex flex-wrap justify-content-center"
                        style={{ gap: '16px', marginTop: '3rem' }}
                    >
                        {[
                            { icon: 'trending-up', label: 'Sales Performance', value: 'Tracked in real time' },
                            { icon: 'zap', label: 'Automation', value: 'Reduce manual tasks' },
                            { icon: 'bar-chart-2', label: 'AI Insights', value: 'Smarter decisions' },
                            { icon: 'shield', label: 'Reliable Platform', value: 'Built for scale' },
                        ].map((stat, i) => (
                            <div
                                key={i}
                                className="d-flex align-items-center"
                                style={{
                                    gap: '12px',
                                    background: '#fff',
                                    border: '1px solid #eaeaea',
                                    borderRadius: '14px',
                                    padding: '14px 20px',
                                    minWidth: '200px',
                                    flex: '1 1 200px',
                                    maxWidth: '260px',
                                    transition: 'box-shadow 0.25s ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.06)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
                            >
                                <div
                                    style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '10px',
                                        background: '#eef2ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                    }}
                                >
                                    <FeatherIcon icon={stat.icon} style={{ width: '17px', height: '17px', color: colors.primary.darkBlue }} />
                                </div>
                                <div>
                                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.6px' }}>{stat.label}</div>
                                    <div style={{ fontSize: '0.88rem', fontWeight: 600, color: '#1a1a2e' }}>{stat.value}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

        </>
    );
};

export default Features;
